<template>
  <el-container direction="vertical">
    <div>导入说明: 请下载模版, 按要求导入 <el-button v-permission="'下载参数模板'" class="btn btn_1" icon="el-icon-download" @click="downTemplate">下载模版</el-button></div>
    <!-- accept="application/vnd.ms-excel" -->
    <el-upload
      ref="upload"
      class="upload-demo"
      drag
      :limit="1"
      :on-exceed="exceed"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :action="uploadAction"
      :data="uploadParams"
      :auto-upload="false">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">注意: 文件后缀名必须为: xls(即Excel格式)</div>
    </el-upload>

    <div>
      <el-button class="btn_dialog qd" @click="confirm">确认导入</el-button>
      <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
    </div>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import Util from '@/api/util'
import RightHelper from '@/api/right_helper'
import GlobalData from '@/api/global_data'

export default {
  name: '',
  data () {
    return {
      uploadAction: Backend.BACKENDURL + '/admin/device_model_parameter/import_parameter_template',
      uploadParams: {
        device_type_id: '',
        device_model_id: ''
      }
    }
  },

  mounted () {
    this.uploadParams.device_type_id = this.deviceTypeId
    this.uploadParams.device_model_id = this.deviceModelId
  },

  props: ['deviceTypeId', 'deviceModelId'],

  watch: {
    deviceTypeId (val) {
      this.uploadParams.device_type_id = val
    },
    deviceModelId (val) {
      this.uploadParams.device_model_id = val
    }
  },

  methods: {
    downTemplate () {
      Backend.post(this, 'device_model_parameter/download_parameter_template').then((res) => {
        Util.downLoadFile(res.download_url)
      })
    },
    beforeUpload (file) {
      return RightHelper.beforeFileUpload(this, file, 'excel', 5)
    },
    handleSuccess (res, file) {
      console.log(res, file)
      if (res.success) {
        this.$message.success('上传成功!')
        this.$emit('tableCloseDialog')
        const pageData = GlobalData.tabShareData['参数列表'].pageData
        if (pageData) {
          res.data.data.forEach(item => {
            pageData.items.unshift(item)
            pageData.total++
          })
        }
      } else {
        this.$refs.upload.clearFiles()
        this.$message.error(res.message)
      }
    },
    exceed (file, fileList) {
      this.$message.warning('当前文件数量已达上限!')
      console.log(file, fileList)
    },
    confirm () {
      this.$refs.upload.submit()
    }
  }
}
</script>
<style lang='scss' scoped>
  .upload-demo{
    margin: 20px 0;
  }
</style>
